module.exports = __webpack_public_path__ + "992459a3d0f22849b493a540e1564bb0.svg";